// comes from old readableData in ajax-offers.js
export default function readableTitle(cardTitle, title) {
  var hasCardTitle = !!cardTitle;
  var hasTitle = !!title;
  var maxTitleLength = 50;

  if (hasCardTitle) {
    return cardTitle;
  }
  if (hasTitle) {
    var tempTitle = title;
    if (tempTitle.length >= maxTitleLength) {
      tempTitle = tempTitle.substr(0, maxTitleLength - 3) + '...';
      return tempTitle;
    }
  }
  return null;
}
